// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-menu ul{display:flex;flex-wrap:wrap;justify-content:center;margin:15px 0 0}.footer-menu ul li{margin:0 15px 15px;padding:0}@media (min-width:1023px){.footer-menu ul li{margin-bottom:0}.footer-menu ul li:last-child{margin-right:0}.footer-menu ul li:first-child{margin-left:0}}.footer-menu ul li:before{display:none}.footer-menu ul li a{color:#1f1f1f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
